/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/img/sweepcoinscash-01.webp";
import { Accordion, Image, Spinner } from 'react-bootstrap';
import CorrectIcon from "../assets/img/check_mark.png";
import CloseNewIcon from "../assets/img/close_mark.png";
import { HOME_URL } from "./Shared/constant";

const LocateCheck = () => {
    const [ loading, setLoading ] = useState(true);
    const [ errorMsg, setErrorMsg ] = useState("");
    const [ iframeGet, setIframeGet ] = useState("");
    const [ data, setData ] = useState(null);
    const navigate = useNavigate();
    const intervalRef = useRef(null);
    const alreadyCheckedId = sessionStorage.getItem("LocateCheckedAuthId");
    const alreadyCheckedSuccess = sessionStorage.getItem("LocateCheckSuccess");
    const isCountryCheckAllow = process.env.REACT_APP_COUNTRY_CHECK_IS_ALLOW === "true";

    const locateApiCall = async () => {
        sessionStorage.setItem("LocateCheckPassed", false);

        try {
            const API_URL = `${process.env.REACT_APP_CHECK_LOCATION_BASE_URL}/assure-locate`;
            const res = await axios.get(API_URL);

            if (res?.status === 200 && res?.data?.data?.evs_url) {
                const evsUrl = res.data.data.evs_url;
                const locateId = res.data.data.id;
                sessionStorage.setItem("LocateCheckedAuthId", locateId);
                setIframeGet(evsUrl);
                setLoading(false);
            } else {
                setLoading(false);
                setErrorMsg("Your location is not whitelisted. Access denied.");
                sessionStorage.removeItem("LocateCheckedAuthId");
            };
        } catch (err) {
            console.error("Locate API error:", err);
            setErrorMsg("Error verifying location. Please try again later.");
            sessionStorage.removeItem("LocateCheckedAuthId");
        } finally {
            setLoading(false);
        };
    };

    useEffect(() => {
        if (!alreadyCheckedId) return;
        const callApi = async () => {
            try {
                const API_URL = `${process.env.REACT_APP_CHECK_LOCATION_BASE_URL}/assure-locate/${alreadyCheckedId}`;
                const response = await axios.get(API_URL);

                // Check if success
                if (response.status === 200) {
                    if(response.data.data.evs_data) {
                        setData(response.data.data.evs_data);
                        setIframeGet("");
                        setLoading(false);
                        sessionStorage.setItem("LocateCheckSuccess", true);

                        // ✅ Stop polling
                        if (intervalRef.current) {
                            clearInterval(intervalRef.current);
                            intervalRef.current = null;
                        };
                    } else {
                        setLoading(false);
                        setData(null);
                        // setIframeGet("");
                        sessionStorage.setItem("LocateCheckSuccess", false);
                    };
                } else {
                    setLoading(false);
                    setData(null);
                    sessionStorage.setItem("LocateCheckSuccess", false);
                };
            } catch (error) {
                setData(null);
                sessionStorage.setItem("LocateCheckSuccess", false);
                console.error("API Error:", error);
            };
        };

        callApi();
        intervalRef.current = setInterval(callApi, 5000);

        // Cleanup on unmount
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
                intervalRef.current = null;
            };
        };
    }, [ alreadyCheckedId ]);

    const evs_data = data;

    useEffect(() => {
        const success = sessionStorage.getItem("LocateCheckSuccess") === "true";
        const checkedId = sessionStorage.getItem("LocateCheckedAuthId");

        if (!checkedId || !success) {
            locateApiCall();
            return;
        }

        // 🚫 Stop if API data not ready
        if (!evs_data?.data?.assureLocate) return;

        const {
            // vpnProbability,
            spoofingTools,
            deviceLocation,
            ipLocation
        } = evs_data.data.assureLocate;

        // const vpnCode = vpnProbability?.code;
        const spoofCode = spoofingTools?.code;

        // ✅ Safer checks
        // const isVpnSafe = ["N", "L", "M"].includes(vpnCode);
        const isSpoofSafe = spoofCode === "N";
        // const isProxySafe = ipLocation?.isProxy === false;
        const isProxySafe = true;

        const isLocationSafe = isLocationAllowed({
            deviceLocation: { country: deviceLocation?.country },
            ipLocation: { province: ipLocation?.province } // ✅ fixed
        });

        const isAllowed =
            // isVpnSafe &&
            isSpoofSafe &&
            isProxySafe &&
            isLocationSafe;

        if (isAllowed) {
            const redirectUrl = sessionStorage.getItem("PostLocationRedirectUrl");

            sessionStorage.setItem("LocateCheckPassed", "true");

            if (redirectUrl && redirectUrl.includes("/reset-password/")) {
                sessionStorage.removeItem("PostLocationRedirectUrl");
                navigate(redirectUrl);
            } else {
                navigate(HOME_URL);
            }
        }

    }, [evs_data, navigate]);

    if (loading) {
        document.getElementById("pageisLoading").style.display = "flex";
    } else {
        document.getElementById("pageisLoading").style.display = "none";
    };

    if(iframeGet) {
        return (<div className="locate-iframe">
            <div className="locate-logo">
                <img src={Logo} alt="" />
            </div>
            <iframe 
                src={iframeGet} 
                title="Location Verification" 
                width="100%" 
                height="600px" 
                allow="geolocation; microphone; camera"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                style={{ border: 'none' }}
            ></iframe>
        </div>);
    };

    const GeoComplyHit = () => {
        setLoading(true);
        setErrorMsg("");
        setData(null);
        locateApiCall();
    };

    function isLocationAllowed({ deviceLocation, ipLocation }) {
        const country = deviceLocation?.country || ipLocation?.country || "";
        const state = ipLocation?.province || "";

        if(isCountryCheckAllow) {
            if (country !== "USA") {
                return false; 
            }

            // Block specific states inside USA
            if (state === "MI" || state === "WA" || !state) {
                return false;
            }
        } else {
            return true;
        }

        // Allow all other countries/states
        return true;
    };

    if(evs_data) {
        // const { vpnProbability, spoofingTools, deviceLocation, ipLocation } = evs_data?.data?.assureLocate || {};
        const { spoofingTools, deviceLocation, ipLocation } = evs_data?.data?.assureLocate || {};
        const isCheckCountry = isLocationAllowed ({ deviceLocation: { country: deviceLocation?.country }, ipLocation: { province: deviceLocation?.province } });
        // const isIpChecked = !ipLocation?.isProxy;
        const isIpChecked = true;

        const isUSAMichigan = deviceLocation?.province === "MI";
        const isUSAWashington = deviceLocation?.province === "WA";

        return (<div className="locate-iframe">
        <div className="locate-logo">
            <img src={Logo} alt="" />
        </div>
        <div className="Error_message_wraps">
            <h4>Could Not Locate You.</h4>
            <small>Please fix these issues then try again.</small>
            <Accordion>
                <div className='row'>
                    <div className='col-md-6'>
                        <h3>You may be out of country or state.</h3>
                        <div className='collpseheader'>
                            {isCheckCountry ? (<Image src={CorrectIcon} alt='success' />) : (<Image src={CloseNewIcon} alt='error' />)}
                            <Accordion.Item eventKey="0">
                                {isCheckCountry ? (<Accordion.Header 
                                    className={isCheckCountry ? "remove_arrow" : ""}
                                    onClick={(e) => isCheckCountry && e.preventDefault()}
                                    style={{ cursor: isCheckCountry ? "not-allowed" : "pointer", opacity: isCheckCountry ? 0.5 : 1 }}
                                    aria-disabled="true"
                                >Your location is permitted.</Accordion.Header>) : (<>
                                    <Accordion.Header>How to fix this?</Accordion.Header>
                                    <Accordion.Body>
                                        Your device's location data indicates you are not in a permitted area. Please make sure that you are within a permitted area, then try again.

                                        {(isUSAMichigan || isUSAWashington) && (<div style={{ marginTop: "15px" }}>
                                            <strong style={{ float: "left", width: "auto", marginRight: "6px", color: "#cd1125", letterSpacing: "0.5px" }}>Access Restricted:</strong> We currently do not support users from the state of {isUSAMichigan ? "Michigan" : "Washington"} (USA).
                                        </div>)}
                                    </Accordion.Body>
                                </>)}
                            </Accordion.Item>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <h3>Spoofing Tools</h3>
                        <div className='collpseheader'>
                            {spoofingTools?.code === "N" ? (<Image src={CorrectIcon} alt='success' />) : (<Image src={CloseNewIcon} alt='error' />)}
                            <Accordion.Item eventKey="1">
                                {spoofingTools?.code === "N" ? (<Accordion.Header
                                    className={spoofingTools?.code === "N" ? "remove_arrow" : ""}   
                                    onClick={(e) => spoofingTools?.code === "N" && e.preventDefault()}
                                    style={{ cursor: spoofingTools?.code === "N" ? "not-allowed" : "pointer", opacity: spoofingTools?.code === "N" ? 0.5 : 1 }}
                                    aria-disabled="true"
                                >No spoofing tools detected.</Accordion.Header>) : (<>
                                    <Accordion.Header>
                                        How to fix this?
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        {spoofingTools?.description && (<p className="mb-1 text-danger"><strong className="w-auto">Error</strong>: {spoofingTools?.description}</p>)}
                                        Try These Steps :
                                        <ol className="mb-0 ps-3">
                                            <li>Clear cache & cookies → restart your browser.</li>
                                            <li>Try in Incognito/Private mode — if it works there, the issue is with an extension.</li>
                                            <li>Update your browser to the latest version.</li>
                                            <li>If you’re a developer working on your own site, remove that detection script in your code (it usually listens for devtoolschange or debugger events).</li>
                                        </ol>
                                    </Accordion.Body>
                                </>)}
                            </Accordion.Item>
                        </div>
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-md-6'>
                        <h3>VPN Detected.</h3>
                        <div className='collpseheader'>
                            <Image src={CorrectIcon} alt='success' />
                            <Accordion.Item eventKey="2">
                                <Accordion.Header
                                    className={"remove_arrow"}   
                                    onClick={(e) => e.preventDefault()}
                                    style={{ cursor: "not-allowed", opacity: 0.5 }}
                                    aria-disabled="true"
                                >No VPN detected.
                            </Accordion.Header>
                            </Accordion.Item>
                        </div>
                    </div>
                    {/* <div className='col-md-6'>
                        <h3>VPN Detected.</h3>
                        <div className='collpseheader'>
                        {(vpnProbability?.code === "N" || vpnProbability?.code === "L" || vpnProbability?.code === "M") ? (<Image src={CorrectIcon} alt='success' />) : (<Image src={CloseNewIcon} alt='error' />)}
                        <Accordion.Item eventKey="2">
                            {(vpnProbability?.code === "N" || vpnProbability?.code === "L" || vpnProbability?.code === "M") ? (<Accordion.Header
                                className={(vpnProbability?.code === "N" || vpnProbability?.code === "L" || vpnProbability?.code === "M") ? "remove_arrow" : ""}
                                onClick={(e) => (vpnProbability?.code === "N" || vpnProbability?.code === "L" || vpnProbability?.code === "M") && e.preventDefault()}
                                style={{ cursor: (vpnProbability?.code === "N" || vpnProbability?.code === "L" || vpnProbability?.code === "M") ? "not-allowed" : "pointer", opacity: (vpnProbability?.code === "N" || vpnProbability?.code === "L" || vpnProbability?.code === "M") ? 0.5 : 1 }}
                                aria-disabled="true"
                            >No VPN detected.</Accordion.Header>) : (<>
                            <Accordion.Header>How to fix this?</Accordion.Header>
                            <Accordion.Body>
                                {vpnProbability?.description && (<p className="mb-1 text-danger"><strong className="w-auto">Error</strong>: {vpnProbability?.description}</p>)}
                                For Security purposes, you are required to turn off browser extensions. Please disable, then try again.
                            </Accordion.Body>
                            </>)}
                        </Accordion.Item>
                        </div>
                    </div> */}
                    {/* Ip check */}
                    <div className='col-md-6'>
                        <h3>Proxy Check</h3>
                        <div className='collpseheader'>
                        {isIpChecked ? (<Image src={CorrectIcon} alt='success' />) : (<Image src={CloseNewIcon} alt='error' />)}
                        <Accordion.Item eventKey="3">
                            {isIpChecked ? (<Accordion.Header
                                className={isIpChecked ? "remove_arrow" : ""}
                                onClick={(e) => isIpChecked && e.preventDefault()}
                                style={{ cursor:  isIpChecked ? "not-allowed" : "pointer", opacity: isIpChecked ? 0.5 : 1 }}
                                aria-disabled="true"
                            >No Proxy detected.</Accordion.Header>) : (<>
                            <Accordion.Header>How to fix this?</Accordion.Header>
                            <Accordion.Body>
                                {isIpChecked && (<p className="mb-1 text-danger"><strong className="w-auto">Error</strong>: {isIpChecked}</p>)}
                                Your connection appears to be routed through a proxy, which is not allowed for security reasons.  Kindly disable the proxy and refresh the page to proceed.
                            </Accordion.Body>
                            </>)}
                        </Accordion.Item>
                        </div>
                    </div>
                </div>
            </Accordion>
            <button type="button" className="btn tryAgainbtn" onClick={() => GeoComplyHit()} style={{ marginTop: "30px" }}>Try again</button>
        </div>
    </div>);
    };

    if (errorMsg) {
        return (<div className="locate-error">
            <h2>Access Denied</h2>
            <p>{errorMsg}</p>
        </div>);
    };

    return (<div className="locate-iframe">
        <div className="locate-logo">
            <img src={Logo} alt="" />
        </div>
        <div className="locate-loader">
            <Spinner />
            <h1>Checking Your Location...</h1>
            <p>Please wait while we verify your access.</p>
        </div>
    </div>);
};

export default LocateCheck;